import PropTypes from 'prop-types';
import useStores from '$src/hooks/useStores';
import { observer } from 'mobx-react';
import OnboardingContainer from '$src/components/OnboardingContainer';
import { WarningIcon } from '@ring-icons';
import { CalloutCard } from '@amzn/ring-react-components/csr/components/CalloutCard';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import aboutImage from '$src/assets/img/onboardingAbout.png';

import './Authorize.less';

function Authorize({ redirect }) {
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <OnboardingContainer
      headerTitle="Authorize Virtual Security Guard"
      icon="ring_protect_inactive.svg"
      title="Virtual Security Guard was not authorized."
      primaryText="Try Again"
      image={aboutImage}
      handleClose={() => handleBackToRingDashboard(isMobile)}
      handleBack={redirect}
      primaryActionHandler={redirect}
      warningOnClose
      data-testid="onboard-page"
    >
      <CalloutCard
        icon={<WarningIcon width="24px" height="24px" />}
        status="error"
        className="authorize__callout-card"
        title="For the service to work, you’ll need to grant access to the devices you choose to enroll."
      >
        This allows Virtual Guards to access Live View on your enrolled devices to monitor events at your property when the service is active and a
        person is detected. Click below to try again.
      </CalloutCard>
    </OnboardingContainer>
  );
}

Authorize.propTypes = {
  redirect: PropTypes.func.isRequired,
};

export default observer(Authorize);
